import { createSlice } from "@reduxjs/toolkit";
import { OrganizationalUnit } from 'types/OrganizationalUnit';

interface organizationalUnitSlice {
  organizationalUnits: OrganizationalUnit[],
}

// Define the initial state using that type
const initialState: organizationalUnitSlice = {
  organizationalUnits: [],
};

export const organizationalUnitSlice = createSlice({
  name: "organizationalunits",
  initialState: initialState,
  reducers: {
    addOrganizationalUnits: (state, action) => {
      state.organizationalUnits = action.payload.organizationalUnits;
    },
  },
});

export const { addOrganizationalUnits } = organizationalUnitSlice.actions;
export default organizationalUnitSlice.reducer;